module.exports = __webpack_public_path__ + "img/clicksend.0acac8d4.png";